export default [
    'LogService',
    function (logService) {
        const log = logService.getLogger('DragFile-C');
        return {
            restrict: 'EA',
            scope: {
                submit: '=',
                onUploading: '=',
            },
            link(scope, element) {
                const DRAGOVER_CSS_CLASS = 'is-dragover';
                const overlay = angular.element(element[0]);
                const dragElement = angular.element(element[0]).parent('.drag-container');
                function fetchFileListContents(fileList) {
                    return new Promise((resolve) => {
                        const buffers = new Map();
                        const next = (file, res, error) => {
                            buffers.set(file, res);
                            if (buffers.size >= fileList.length) {
                                resolve(buffers);
                            }
                            if (error !== undefined) {
                                log.error('Error:', error);
                            }
                        };
                        for (let n = 0; n < fileList.length; n++) {
                            const reader = new FileReader();
                            const file = fileList.item(n);
                            reader.onload = function (ev) {
                                next(file, this.result);
                            };
                            reader.onerror = function (ev) {
                                next(file, null, ev);
                            };
                            reader.onprogress = function (ev) {
                                if (ev.lengthComputable) {
                                    const progress = ((ev.loaded / ev.total) * 100);
                                    scope.onUploading(true, progress, 100 / fileList.length * n);
                                }
                            };
                            reader.readAsArrayBuffer(file);
                        }
                    });
                }
                function uploadFiles(fileList) {
                    scope.onUploading(true, 0, 0);
                    fetchFileListContents(fileList).then((data) => {
                        const fileMessages = [];
                        data.forEach((buffer, file) => {
                            const fileMessageData = {
                                name: file.name,
                                fileType: file.type,
                                size: file.size,
                                data: buffer,
                            };
                            fileMessages.push(fileMessageData);
                        });
                        scope.submit('file', fileMessages);
                        scope.onUploading(false);
                    }).catch((ev) => {
                        log.error('Could not load file:', ev.message);
                    });
                }
                function onDrop(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onDragLeave(ev);
                    uploadFiles(ev.dataTransfer.files);
                }
                function onDragOver(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    dragElement.addClass(DRAGOVER_CSS_CLASS);
                }
                function onDragLeave(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    dragElement.removeClass(DRAGOVER_CSS_CLASS);
                }
                scope.$on('$destroy', scope.stopTyping);
                dragElement.on('dragover dragenter', onDragOver);
                overlay.on('dragleave dragend', onDragLeave);
                overlay.on('drop', onDrop);
            },
            template: `
                <div class="drag-file-overlay">
                    <div>
                        <span translate>messenger.COMPOSE_MESSAGE_DRAGOVER</span>
                     </div>
                </div>`,
        };
    },
];
